import rawConfig from "./config.json";
import { IConfig, IApi, IGeneral, IMap } from './config';

// All configurations are converted into typescript objects
export const config: IConfig = {
    old_backendURL: rawConfig.old_backendURL,
    backendURL: rawConfig.backendURL,
    api: rawConfig.api as IApi,
    general: rawConfig.general as IGeneral,
    map: rawConfig.map as IMap
};

